import { useState, useEffect } from 'react';

export const getDeviceType = (): 'mobile' | 'desktop' => {
  if (typeof window === 'undefined') return 'desktop';

  // 1. Sprawdzenie dotyku (podstawa mobilności)
  const hasTouch = navigator.maxTouchPoints > 0;
  
  // 2. Sprawdzenie szerokości
  // Używamy Math.min, aby złapać krótszy bok urządzenia (na telefonach zawsze < 1024)
  const width = window.innerWidth;
  const screenWidth = window.screen.width;
  
  // Uznajemy za mobile, jeśli aktualne okno LUB fizyczny ekran jest wąski
  const isSmallScreen = width <= 1024 || screenWidth <= 1024;

  if (isSmallScreen && hasTouch) {
    return 'mobile';
  }

  return 'desktop';
};

export const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<'mobile' | 'desktop'>(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      // Wykonujemy natychmiast bez setTimeout
      setDeviceType(getDeviceType());
    };

    // 'resize' zazwyczaj wystarcza, ale na iOS 'orientationchange' 
    // jest pewniejszym sygnałem do przeliczenia layoutu
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return deviceType;
};